import React, {Fragment} from "react";
import {CredentialsType, IDataPointCredentials} from "@leap4/entities-discrepancy-common";
import {enumNamesToSelect, Grid, TextField, Typography} from "@leap4/frontend";

interface IProps {
    credentials: IDataPointCredentials;
    handleCredentialsPropChange: any;
    adServerName: string
}

const AuthToken = ({handleCredentialsPropChange, credentials}) => <TextField
    key={"auth"}
    variant="outlined"
    margin="normal"
    type="token"
    required
    fullWidth
    label="Auth Token"
    name="authToken"
    autoComplete="authToken"
    onChange={handleCredentialsPropChange}
    value={credentials.authToken}
/>

const Password = ({handleCredentialsPropChange, credentials}) => <>
    <Grid item xs={12} sm={8} md={6} key={"username"}>
        <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            type="text"
            label="Username"
            name="username"
            autoComplete="username"
            onChange={handleCredentialsPropChange}
            value={credentials.username}
        />
    </Grid>
    <Grid item xs={12} sm={8} md={6}>
        <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            type="password"
            label="Password"
            name="password"
            autoComplete="password"
            onChange={handleCredentialsPropChange}
            value={credentials.password}
        />
    </Grid>
</>
const PublisherId = ({handleCredentialsPropChange, credentials}) => <Grid key={"pub-id"} item xs={12} sm={8} md={4}>
    <TextField
        variant="outlined"
        margin="normal"
        type="text"
        required
        fullWidth
        label="Publisher ID"
        name="publisherId"
        autoComplete="Publisher ID"
        inputProps={{customData: 'publisherId'}}
        onChange={handleCredentialsPropChange}
        value={credentials.customData?.publisherId}
    />
</Grid>

export const CredentialsForm = ({credentials, handleCredentialsPropChange, adServerName}: IProps): JSX.Element => {
    const CredentialsTypeSelect = enumNamesToSelect(CredentialsType);

    return <Fragment>
        <Grid sm={12}/>
        {(() => {
            switch (adServerName) {
                case "madhivefilmzie":
                case "MadhiveV2":
                case "medhive": {
                    return <></>
                }
                case "freewheel": {
                    return <>
                        <Grid item xs={3} style={{marginTop: "4vh"}}>
                            <Typography variant="h5">
                                CREDENTIALS
                            </Typography>
                        </Grid>
                        <Grid container spacing={"5px"}>
                            <AuthToken credentials={credentials}
                                       handleCredentialsPropChange={handleCredentialsPropChange}/>
                        </Grid>

                    </>
                }
                case "teads":
                case "publica": {
                    return <>
                        <Grid item xs={3} style={{marginTop: "4vh"}}>
                            <Typography variant="h5">
                                CREDENTIALS
                            </Typography>
                        </Grid>
                        <Grid container spacing={"5px"}>
                            <AuthToken credentials={credentials}
                                       handleCredentialsPropChange={handleCredentialsPropChange}/>
                            <Password credentials={credentials}
                                      handleCredentialsPropChange={handleCredentialsPropChange}/>
                        </Grid>

                    </>
                }
                case "pubmatic":
                case "bidscube": {
                    return <>
                        <Grid item xs={3} style={{marginTop: "4vh"}}>
                            <Typography variant="h5">
                                CREDENTIALS
                            </Typography>
                        </Grid>
                        <AuthToken credentials={credentials}
                                   handleCredentialsPropChange={handleCredentialsPropChange}/>
                    </>

                }
                default: {
                    return <>
                        <Grid item xs={3} style={{marginTop: "4vh"}}>
                            <Typography variant="h5">
                                CREDENTIALS
                            </Typography>
                        </Grid>
                        <Password credentials={credentials}
                                  handleCredentialsPropChange={handleCredentialsPropChange}/>
                    </>

                }
            }
        })()}
    </Fragment>
}